import { FeedbackFormData, QuestionType } from './interfaces';

export const officeHoursFeedbackFormData: FeedbackFormData = {
  id: 'office-hours-feedback',
  formTitle: 'Tell us about your Office Hours session',
  steps: [
    {
      id: 'session-usefulness',
      type: QuestionType.HAPPINESS,
      title: 'How useful did you find this session?',
    },
    {
      id: 'recommend-likelihood',
      type: QuestionType.RATE,
      title: 'How likely are you to recommend Office Hours to other new joiners',
      subtitle: 'From 1 = never recommend to 5 = definitely recommend',
      minValue: 1,
      maxValue: 5,
    },
    {
      id: 'session-improvements',
      type: QuestionType.TEXTAREA,
      title: 'What can we do to improve these sessions?',
      placeholder: 'Type your suggestions here',
      maxLength: 1000,
    },
  ],
};
